<!-- FILE GENERATED BY packages/components/design-tokens/build-scripts/generate-icons.js DO NOT CHANGE -->

<svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    data-token-name="IconHospital_16"
    viewBox="0 0 16 16"
    aria-hidden="true"
>
    <path
        fill="currentColor"
        fill-rule="evenodd"
        d="M1.751 4.56A2 2 0 0 0 1 6.123v7.833c0 .424.164.831.456 1.131.291.3.687.468 1.1.468h10.888c.413 0 .809-.168 1.1-.468.292-.3.456-.707.456-1.13V6.121a2 2 0 0 0-.751-1.562l-5-3.997a2 2 0 0 0-2.498 0l-5 3.997ZM7 6.051h2v2h2v2H9v2H7v-2H5v-2h2v-2Z"
        clip-rule="evenodd"
    />
</svg>
